var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMapMinimized = function SvgMapMinimized(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_14056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.886 6.67h4.442a.555.555 0 0 0 0-1.111h-3.102L19.83.955a.555.555 0 1 0-.785-.785l-4.604 4.604V1.672a.555.555 0 1 0-1.11 0v4.442c0 .306.248.555.555.555zM6.114 13.331H1.672a.555.555 0 1 0 0 1.11h3.102L.17 19.045a.555.555 0 1 0 .785.785l4.604-4.604v3.102a.555.555 0 0 0 1.11 0v-4.442a.555.555 0 0 0-.555-.555zM15.226 14.441h3.102a.555.555 0 0 0 0-1.11h-4.442a.555.555 0 0 0-.555.555v4.442a.555.555 0 1 0 1.11 0v-3.102l4.604 4.604a.555.555 0 0 0 .785-.785l-4.604-4.604zM6.114 1.117a.555.555 0 0 0-.555.555v3.102L.955.17A.555.555 0 0 0 .17.955l4.604 4.604H1.672a.555.555 0 1 0 0 1.11h4.442a.555.555 0 0 0 .555-.555V1.672a.555.555 0 0 0-.555-.555z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_14056"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMapMinimized;